export default __webpack_public_path__ + "static/media/mobdev.5fac08e7.jpg";